import { render, staticRenderFns } from "./EstoqueModalManage.vue?vue&type=template&id=037f2bbe&scoped=true"
import script from "./EstoqueModalManage.vue?vue&type=script&lang=js"
export * from "./EstoqueModalManage.vue?vue&type=script&lang=js"
import style0 from "./EstoqueModalManage.vue?vue&type=style&index=0&id=037f2bbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037f2bbe",
  null
  
)

export default component.exports